import {
  httpGBarbosa,
  httpMercantil,
  httpBretas,
  httpPerini,
  httpPrezunic,
  httpSpid,
} from '../../services/store/Http.interceptor';
import { ResponsePagination } from '../../core/interfaces/ResponsePagination';
import { http } from '../../services/apiSecurity/Http.interceptor';
import StoreList, { Store } from './interfaces/Store';

const URL: string = '/stores';

const URL2: string = '/bandeira?pagina=1&limitePagina=500&exibirTodas=False';

export const getStore = (aplicativoId: String) => {
  if (aplicativoId === '308238f8-1ccc-788c-982e-4ed43e7b51e6') {
    return httpGBarbosa.get<Store[]>(URL2);
  } else if (aplicativoId === '807238f8-1ccc-488c-982e-4ed43e7b51e6') {
    return httpMercantil.get<Store[]>(URL2);
  } else if (aplicativoId === '908238f8-1ccc-488c-982e-4ed43e7b51e6') {
    return httpPrezunic.get<Store[]>(URL2);
  } else if (aplicativoId === '108238f8-1ccc-488c-982e-4ed43e7b51e6') {
    return httpBretas.get<Store[]>(URL2);
  } else if (aplicativoId === '708238f8-1ccc-488c-982e-4ed43e7b51e6') {
    return httpSpid.get<Store[]>(URL2);
  } else {
    return httpPerini.get<Store[]>(URL2);
  }
};

export const getStores = (flag: String) => {
  return http.get<StoreList[]>(`/listAllStores?flagId=${flag}`);
};

export const getStoresMultiFlags = (params?: any) => {
  return http.get<StoreList[]>(`/listAllStores`, { params: params });
};

export const getStoresPagination = (params?: any) => {
  return http.get<ResponsePagination>(URL, { params: params });
};

export const getByStore = (id: string) => {
  return http.get<Store>(`${URL}/${id}`);
};

export const postStore = (data: Store) => {
  return http.post<Store>(URL, data);
};

export const deleteStore = (id: string) => {
  return http.delete<string>(`${URL}/${id}`);
};

export const putStore = (data: Store) => {
  return http.put<Store>(`${URL}/${data.id}`, data);
};
